export {
  generateBulkId,
  processSheetProducts,
} from './helpers/processSheetProducts'

export const getShopKey = (url: string | null | undefined): string => {
  if (!url) return ''
  try {
    const shopUrl = new URL(url)
    // Force https protocol
    shopUrl.protocol = 'https:'
    return shopUrl.origin
  } catch (e) {
    // noop
    return ''
  }
}

export const isValidUrl = (url?: string): URL | boolean => {
  if (!url) return false

  try {
    // if url does not start with http or https, add https
    if (!url.startsWith('http:/') && !url.startsWith('https:/')) {
      url = `https://${url}`
    }

    // if url has invalid origin e.g https://.www. clean it up
    if (url.startsWith('https://.www.')) {
      url = url.replace('https://.www.', 'https://www.')
    }

    const urlObj = new URL(url)
    return urlObj.hostname.indexOf('.') > -1 ? urlObj : false
  } catch (e) {
    return false
  }
}

/**
 * Convert an image URL to use the img-proxy service
 * @param url The original image URL
 * @param options Configuration options
 * @returns The proxied image URL
 */
export const imgProxy = (
  url: string | null | undefined,
  options: {
    forceCors?: boolean
  } = {}
): string => {
  if (!url) return ''

  // If already using proxy, return as is
  if (url.includes('img-proxy.crrt.dev')) {
    return url
  }

  // Validate URL before encoding
  const validUrl = isValidUrl(url)
  if (!validUrl) {
    return ''
  }

  const proxyUrl = `https://img-proxy.crrt.dev/${safeEncodeUrl(url)}`
  const corsProxyUrl = `https://corsproxy.io/?key=e8c699be&url=${safeEncodeUrl(url)}`
  return options.forceCors ? corsProxyUrl : proxyUrl
}

export const currencySymbolToCode = (symbol: string): string => {
  switch (symbol) {
    case '£':
      return 'GBP'
    case '€':
      return 'EUR'
    case '$':
      return 'USD'
    default:
      return symbol
  }
}

/**
 * Safely encode a URL, preventing double encoding
 * @param url The URL to encode
 * @returns The safely encoded URL
 */
export const safeEncodeUrl = (url: string) => {
  try {
    // Try to decode first in case it's already encoded
    const decoded = decodeURIComponent(url)
    const cleaned = decoded.replace("'", '')
    // Only replace + with %2B for Bing URLs
    const final = url.includes('th.bing.com')
      ? cleaned.replace(/\+/g, '%2B')
      : cleaned
    return encodeURIComponent(final)
  } catch {
    // If decoding fails, it wasn't encoded, so encode it
    const cleaned = url.replace("'", '')
    // Only replace + with %2B for Bing URLs
    const final = url.includes('th.bing.com')
      ? cleaned.replace(/\+/g, '%2B')
      : cleaned
    return encodeURIComponent(final)
  }
}
